<template>
<div class="container">
  <div class="home-right__bottom">
    <div class="home-right__bottom__title">专题专栏
    <span class="con-span" @click="toNew(getZlList[0].id)">更多></span>
    </div>
    <div style="display: flex; flex-direction: row; justify-content: space-between;">
      <img
      :width="1180 / getZlList.length - 20"
      v-for="(item,index) in getZlList"
      :key="index"
      :src="item.image" alt="出错" @click="toNew(item.id)">
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "Topic",
  data(){
    return{
    images:[]
    }
  },
  props:{
    getZlList:{
      type:Array
    }
  },
  watch:{
    getZlList:function (){
  // this.images=this.getZlList[0].image.split(',')
    }
  },
  methods:{
    toNew(id){
      this.$router.push(`/news/${id}`)
    }
  }
}
</script>

<style scoped>
.container{
  background-color: white;
  margin-top: 20px;
  padding: 10px 10px;
 box-sizing: border-box;
}
.home-right__bottom__title{
  position: relative;
  padding: 0 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #d0d0d0;
  font-size: 16px;
  font-weight: bold;
  color: red;
  line-height: 30px;
}
.con-span{
  position: absolute;
  right: 0;
  cursor: pointer;
  color: #303133;
  font-weight: 400;
}
.home-right__bottom img{
  /* width: 240px; */
  height: 170px;
  margin-right: 10px;
}
.home-right__bottom img:last-child{
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Topic.vue